<template>
  <modal>
    <div class="modal-form bounce-modal">
      <div class="modal-form-header">Bounce Mix</div>
      <div class="modal-form-main">
        <div class="modal-form-field">
          <label>Bitrate</label>
          <picker
            :options="bitrates"
            :value="bitrate"
            @pick="bitrate = $event"
            key-field="key"
            label-field="label"
          />
        </div>
        <div class="modal-form-field">
          <label>Quality</label>
          <input
            type="number"
            class="input"
            min="0"
            max="9"
            v-model="quality"
          />
        </div>
        <div class="modal-form-field">
          <label>Samplerate</label>
          <picker
            :options="samplerates"
            :value="samplerate"
            @pick="samplerate = $event"
            key-field="key"
            label-field="label"
          />
        </div>
        <div class="modal-form-buttons">
          <button @click.prevent.stop="onOk" class="btn-outline btn-download">
            <cloud-arrow-down-icon />
            Download
          </button>
          <button @click.prevent.stop="onCancel" class="btn-outline">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import Modal from "./Modal.vue";
import { Options, Vue } from "vue-class-component";
import { CloudArrowDownIcon } from "@heroicons/vue/24/outline";
import Picker from "./Picker.vue";

const bitrates = [
  "32",
  "40",
  "48",
  "56",
  "64",
  "80",
  "96",
  "112",
  "128",
  "160",
  "192",
  "224",
  "256",
  "320",
];

const samplerates = ["22050", "24000", "44100", "48000"];

@Options({
  components: {
    Modal,
    Picker,
    CloudArrowDownIcon,
  },
  data() {
    return {
      bitrate: null,
      samplerate: null,
      quality: 7,
    };
  },
})
export default class BounceModal extends Vue {
  bitrate!: { key: string; label: string } | null;
  samplerate!: { key: string; label: string } | null;
  quality!: number;

  get bitrates() {
    return bitrates.map((btr) => ({ key: btr, label: `${btr} kbps` }));
  }

  get samplerates() {
    return samplerates.map((item) => ({
      key: item,
      label: item + " hz",
    }));
  }

  created() {
    this.bitrate = this.bitrates[8];
    this.samplerate = this.samplerates[2];
  }

  onOk() {
    this.$store.dispatch("mixes/bounce", {
      bitrate: this.bitrate!.key,
      samplerate: this.samplerate!.key,
      quality: this.quality,
    });
    this.$emit("close");
  }

  onCancel() {
    this.$emit("close");
  }
}
</script>

<style lang="scss">
.btn-download {
  svg {
    width: 16px;
    margin-top: -5px;
    position: relative;
    top: 3.5px;
  }
}

.bounce-modal input[type="number"] {
  text-align: center;
}

.modal-form-field {
  label {
    display: block;
    margin-bottom: 2px;
  }
  input.input {
    width: 100%;
  }
  margin-bottom: 8px;
}
</style>
